import FormInputTypes from '../../components/atoms/formEnums/formInputTypes';
import { IconType } from '../../components/atoms/icon/icon';
import formTeamsContent from './formTeamsContent';
// import formSportRoomConfigContentMassUpdate from './formSportRoomConfigContentMassUpdate';
export default {
  attributeName: 'teamsTable',
  isDragable: false,
  canOpen: true,
  canEdit: false,
  canCreate: false,
  canRemove: true,
  isMultiSelectable:false,
  newButton:true,
  editURL:'teams/appId',
  getURL:'teams/appId',
  updateURL:'teams/appId',
  removeURL:'teams/appId',
  deleteRecordText:"You are about to delete a team. Are you totally sure?",
  popupContentFormNew:[formTeamsContent],
  popupContentFormEdit:[formTeamsContent],
  // popupContentFormSecondary:[formSportRoomConfigContentMassUpdate],
  sessionParams: ['appId'],

  emptyMessage: "You don't have any graphic manifest on this manager, click on the \"+\" icon to create one.",
  fields: [
    {
      attributeName: 'short',
      label: 'Short name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canEdit: true,
      canCreate: true,
      canFilter: true,
      helpText: 'Name of the manifest.',
      exactWidth:'120px'
    },
    {
      attributeName: 'name',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canEdit: true,
      canCreate: true,
      canFilter: true,
      helpText: 'Name of the manifest.',
    },
    {
      attributeName: 'info',
      label: 'Info',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canEdit: true,
      canCreate: true,
      canFilter: true,
      helpText: 'Name of the manifest.',
      exactWidth:'200px'

    },
    {
      attributeName: 'logo',
      label: 'Logo',
      type: FormInputTypes.DOWNLOADABLE,
      helpText: 'Logo of the team',
      placeholder: 'Logo...',
      canEdit: true,
      canCreate: true,
      hasSelect: false,
      fileType:['image/*'],
      exactWidth:'120px'

    },
    {
      attributeName: 'blackoutLink',
      label: 'Blackouts',
      type: FormInputTypes.LINK,
      icon: IconType.BLACKOUTS,
      width: '4rem',
      target:'_self',
      iconSize:'2x',
      iconColor:'#17a2b8',
      helpText: 'Live monitor for this event.',
      exactWidth:'150px'
    },   
  ],
};
